import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { C } from '../../styles/tokens';
import { getComparePlans, getCompareRows, COMPARE_CATEGORIES } from '../../constants/planCompare';

function renderCell(v) {
  if (v === true) return <Check size={13} color={C.g500} />;
  if (v === false) return <span style={{ color: C.n300, fontSize: 14 }}>—</span>;
  return <span style={{ fontSize: 12.5, color: C.n700 }}>{v}</span>;
}

export default function ComparePlans() {
  const [cat, setCat] = useState(COMPARE_CATEGORIES[0].id);
  const plans = getComparePlans();
  const rows = getCompareRows(plans)[cat] || [];

  return (
    <div style={{ marginBottom: 26 }}>
      <h2 style={{ fontSize: 17, fontWeight: 800, color: C.n900, marginBottom: 14, letterSpacing: '-.01em' }}>
        Compare plans
      </h2>
      <div style={{ display: 'flex', gap: 6, marginBottom: 14, overflowX: 'auto', paddingBottom: 2 }}>
        {COMPARE_CATEGORIES.map((c) => (
          <button
            key={c.id}
            onClick={() => setCat(c.id)}
            style={{
              padding: '6px 13px', borderRadius: 999, fontSize: 12.5, fontWeight: cat === c.id ? 700 : 500,
              whiteSpace: 'nowrap', border: '1px solid ' + (cat === c.id ? C.n900 : C.n200),
              background: cat === c.id ? C.n900 : C.w, color: cat === c.id ? C.w : C.n600, cursor: 'pointer',
            }}
          >
            {c.label}
          </button>
        ))}
      </div>
      <div style={{ background: C.w, border: '1px solid ' + C.n200, borderRadius: 13, overflow: 'hidden' }}>
        <div
          style={{
            display: 'grid', gridTemplateColumns: `1.1fr repeat(${plans.length},1fr)`,
            padding: '11px 10px', borderBottom: '1px solid ' + C.n200, background: C.n50, gap: 4,
          }}
        >
          <div />
          {plans.map((p) => (
            <div key={p.plan_id_usd || p.plan_title} style={{ fontSize: 12, fontWeight: 700, color: C.n900, textAlign: 'center' }}>
              {p.plan_title}
            </div>
          ))}
        </div>
        {rows.map((row, i) => (
          <div
            key={row.label}
            style={{
              display: 'grid', gridTemplateColumns: `1.1fr repeat(${plans.length},1fr)`,
              padding: '11px 10px', borderBottom: i < rows.length - 1 ? '1px solid ' + C.n100 : 'none',
              alignItems: 'center', gap: 4,
            }}
          >
            <div style={{ fontSize: 12.5, color: C.n600, fontWeight: 500 }}>{row.label}</div>
            {plans.map((_, j) => (
              <div key={j} style={{ textAlign: 'center' }}>{renderCell(row.values[j] ?? '—')}</div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
